import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

export class CustomLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http
      .get<{ [id: string]: { [id: string]: string } }>(
        `assets/i18n/strings-${lang}.json?d=${new Date().getTime()}`
      )
      .pipe(map((result) => result));
  }
}
